import { render } from "./CurrencyList.vue?vue&type=template&id=547559be&scoped=true&ts=true"
import script from "./CurrencyList.vue?vue&type=script&lang=ts"
export * from "./CurrencyList.vue?vue&type=script&lang=ts"

import "./CurrencyList.vue?vue&type=style&index=0&id=547559be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-547559be"]])

export default __exports__